<template>
    <div
        class="btn-switcher btn-group btn-group-toggle"
        :class="{ 'btn-switcher--disabled': disabled }"
    >
        <label
            class="btn"
            :class="{
                'btn-success': isYes,
                'btn-default': !isYes,
                'btn-sm': size === 'sm',
            }"
        >
            <input
                v-model="value"
                type="radio"
                :name="name"
                autocomplete="off"
                :value="1"
                :disabled="disabled"
            />
            <span>{{ $t('yes') }}</span>
        </label>

        <label
            class="btn"
            :class="{
                'btn-danger': !isYes,
                'btn-default': isYes,
                'btn-sm': size === 'sm',
            }"
        >
            <input
                v-model="value"
                type="radio"
                :name="name"
                autocomplete="off"
                :value="0"
                :disabled="disabled"
            />
            <span>{{ $t('no') }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, Object, Boolean],
            default: false,
        },
        name: {
            type: String,
            default: 'switcher',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: '',
        },
    },
    computed: {
        value: {
            get() {
                return this.$attrs.value;
            },
            set(value) {
                if (value.toString() != this.value.toString()) {
                    this.$emit('input', typeof this.$attrs.value === 'boolean' ? !!value : value);
                }
            },
        },
        isYes() {
            return this.value === 1 || !!this.value;
        },
    },
};
</script>

<style scoped>
.btn-switcher {
    width: 100%;
    position: relative;
}

.btn-switcher .btn {
    min-width: 50px;
}

.btn-switcher--disabled .btn {
    opacity: 0.65;
    cursor: not-allowed;
}

.btn-switcher--disabled .btn-success {
    background-color: #37805f;
    border-color: #37805f;
}

.btn-switcher--disabled .btn-danger {
    background-color: #815a55;
    border-color: #815a55;
}

.btn-switcher input {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
}
</style>
